import { api } from './client';

export type AuthOperator = {
  id: number;
  username: string;
  displayName: string;
};

export const login = (username: string, password: string) =>
  api.post<{ operator: AuthOperator }>('/auth/login', { username, password });

export const logout = () => api.post<{ ok: true }>('/auth/logout', {});

export const me = () => api.get<{ operator: AuthOperator }>('/auth/me');
